import { render, staticRenderFns } from "./CardSimple.vue?vue&type=template&id=4438a0c9&scoped=true"
import script from "./CardSimple.vue?vue&type=script&lang=js"
export * from "./CardSimple.vue?vue&type=script&lang=js"
import style0 from "./CardSimple.vue?vue&type=style&index=0&id=4438a0c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4438a0c9",
  null
  
)

export default component.exports